export default {
  page_title: 'Consumptions',
  page_description: 'Track consumable resource usage',
  editTitle: 'Edit Consumption',
  consume_resource: 'Consume Resource',
  resource: 'Resource',
  user: 'User',
  quantity_consumed: 'Quantity Consumed',
  consumed_date: 'Consumed Date',
  notes: 'Notes',
  notes_placeholder: 'Enter any notes about this consumption...',
  quantity_to_consume: 'Quantity to Consume',
  available_quantity: 'Available Quantity',
  consume: 'Consume',
  consumed_successfully: 'Resource consumed successfully',
  invalid_quantity: 'Quantity must be greater than 0',
  insufficient_quantity: 'Not enough quantity available',
  unknown_resource: 'Unknown Resource',
  unknown_user: 'Unknown User',
  units: 'units'
};
